import templateUrl from './termsConditions.html';
export const TermsConditions = { templateUrl };



// WEBPACK FOOTER //
// ./src/components/TermsConditions/index.js